import React from "react";
import shape from "../../assets/images/svg/shape.svg";

const Choose = () => {
  return (
    <section
      className="as_whychoose_wrapper as_padderTop80 as_padderBottom50"
      id="choose"
    >
      <div className="container">
        <div className="row as_verticle_center">
          <div
            className="col-lg-3 col-md-12"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <h1 className="as_heading as_heading_center chooseus">
              Why Choose Us
            </h1>
            <p
              className="as_font14 as_margin0"
              style={{ textAlign: "center", marginBottom: "25px" }}
            >
              We have provided your services in astrology for
              <strong> 17 years </strong>and we have{" "}
              <strong>Thousands of valuable customers</strong> with 100%
              results. We have created thousands of valuable horoscopes with{" "}
              <strong>accurate results.</strong>
            </p>
          </div>
          <div
            className="col-lg-9 col-md-12"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <div className="as_whychoose_box text-center">
                  <span className="as_number">
                    <span>
                      <span data-from="0" data-to="512" data-speed="5000">
                        1
                      </span>
                    </span>
                    <img src={shape} alt="" />
                  </span>
                  <h4>Gold medalist astrologer</h4>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <div className="as_whychoose_box text-center">
                  <span className="as_number">
                    <span>
                      <span data-from="0" data-to="62" data-speed="5000">
                        100000
                      </span>
                      +
                    </span>
                    <img src={shape} alt="" />
                  </span>
                  <h4>Success Horoscope</h4>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <div className="as_whychoose_box text-center">
                  <span className="as_number">
                    <span>
                      <span data-from="0" data-to="452" data-speed="5000">
                        10000
                      </span>
                      +
                    </span>
                    <img src={shape} alt="" />
                  </span>
                  <h4>Trust by thousands of clients</h4>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <div className="as_whychoose_box text-center">
                  <span className="as_number">
                    <span>
                      <span data-from="0" data-to="12" data-speed="5000">
                        17
                      </span>
                      +
                    </span>
                    <img src={shape} alt="" />
                  </span>
                  <h4>Year experience</h4>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                <div className="as_whychoose_box text-center">
                  <span className="as_number">
                    <span>
                      <span data-from="0" data-to="652" data-speed="5000">
                        10
                      </span>
                      +
                    </span>
                    <img src={shape} alt="" />
                  </span>
                  <h4>Type of horoscopes</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Choose;
